import { scaleToFit } from '../../Utils/Utils';
import MultiStyleText from './Text/MultiStyleText';
import Core from '../../Core/Core';

export default class SpeechBox extends PIXI.Sprite {
    public bg: PIXI.Sprite;
    public textBox: PIXI.Text;

    constructor(invert = false) {
        super();

        this.bg = new PIXI.Sprite(PIXI.utils.TextureCache['tutorial/speechBubble']);
        this.bg.anchor.set(0.5);
        this.bg.scale.set(1.3);
        this.bg.scale.x *= invert ? -1 : 1;
        if (Core.local.languageKey === 'ru') {
            this.textBox = new MultiStyleText('', {
                default: {
                    align: 'center',
                    fill: 0x006eba,
                    fontFamily: 'Marmelad',
                    fontStyle: 'Bold',
                    fontSize: 26,
                    lineHeight: 26,
                    wordWrap: true,
                    wordWrapWidth: this.bg.width * 0.85,
                },
                high: {
                    fill: 0xd53700,
                },
            });
        } else {
            this.textBox = new MultiStyleText('', {
                default: {
                    align: 'center',
                    fill: 0x006eba,
                    fontFamily: 'Baloo',
                    fontSize: 26,
                    lineHeight: 26,
                    wordWrap: true,
                    wordWrapWidth: this.bg.width * 0.85,
                },
                high: {
                    fill: 0xd53700,
                },
            });
        }

        this.textBox.anchor.set(0.5);

        this.addChild(this.bg, this.textBox);
    }

    // txt position
    public showTxt(txt: string) {
        this.textBox.text = txt;
        this.textBox.y = -this.bg.height * 0.1;
    }

    public scaleTxt() {
        this.textBox.scale.set(
            scaleToFit(
                this.textBox.getBounds().width,
                this.textBox.getBounds().height,
                this.bg.width * 0.7,
                this.bg.height * 0.55
            )
        );
    }
}
